module.exports = __webpack_public_path__ + "src/assets/img/photo_dahsolar1.6ac8560a.jpg";